import WishedExpeditionDate from './WishedExpeditionDate'

export default WishedExpeditionDate
